import { get } from 'lodash';
import config from 'config';
import { insideReactNative } from 'react-native/lib/platform';

export function pushNotificationsFeatureEnabled() {
  return config.pushNotificationsEnabled && insideReactNative()
    && get(window, [ '__MADLAN_MOBILE_CONFIG__', 'hasPushCapability' ]);
}
